var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.87988 18.4001C6.74603 18.4001 6.62988 18.2839 6.62988 18.1501V16.0801C6.62988 15.9462 6.74603 15.8301 6.87988 15.8301C7.01374 15.8301 7.12988 15.9462 7.12988 16.0801V18.1501C7.12988 18.2896 7.0181 18.4001 6.87988 18.4001Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 18.4C11.8661 18.4 11.75 18.2839 11.75 18.15V14C11.75 13.8661 11.8661 13.75 12 13.75C12.1339 13.75 12.25 13.8661 12.25 14V18.15C12.25 18.2895 12.1382 18.4 12 18.4Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.1201 18.3997C16.9863 18.3997 16.8701 18.2835 16.8701 18.1497V11.9297C16.8701 11.7958 16.9863 11.6797 17.1201 11.6797C17.254 11.6797 17.3701 11.7958 17.3701 11.9297V18.1497C17.3701 18.2935 17.264 18.3997 17.1201 18.3997Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.81855 12.1862L6.81855 12.1862L6.82134 12.1855C10.6024 11.2402 13.9322 9.17423 16.4691 6.22657L16.4707 6.22464L16.9284 5.68728C17.0194 5.58444 17.1751 5.57031 17.2846 5.66003C17.3869 5.75184 17.4 5.90824 17.3084 6.01735C17.3083 6.01756 17.3081 6.01777 17.3079 6.01797L16.8502 6.55531C16.8501 6.55546 16.8499 6.5556 16.8498 6.55574C14.2477 9.59627 10.8185 11.7103 6.93938 12.6752L6.92046 12.6799L6.91996 12.6801C6.91843 12.6801 6.91667 12.6802 6.91466 12.6802C6.90573 12.6804 6.89594 12.6804 6.88007 12.6804C6.7716 12.6804 6.66823 12.608 6.63435 12.4859C6.60278 12.3523 6.68269 12.2193 6.81855 12.1862Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.8699 6.59961V6.09961H16.3699H14.1899C14.0561 6.09961 13.9399 5.98347 13.9399 5.84961C13.9399 5.71575 14.0561 5.59961 14.1899 5.59961H17.1199C17.2538 5.59961 17.3699 5.71575 17.3699 5.84961V8.77961C17.3699 8.90909 17.2682 9.01961 17.1199 9.01961C16.9861 9.01961 16.8699 8.90347 16.8699 8.76961V6.59961Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15 22.25H9C6.3424 22.25 4.56492 21.6803 3.4423 20.5577C2.31968 19.4351 1.75 17.6576 1.75 15V9C1.75 6.3424 2.31968 4.56492 3.4423 3.4423C4.56492 2.31968 6.3424 1.75 9 1.75H15C17.6576 1.75 19.4351 2.31968 20.5577 3.4423C21.6803 4.56492 22.25 6.3424 22.25 9V15C22.25 17.6576 21.6803 19.4351 20.5577 20.5577C19.4351 21.6803 17.6576 22.25 15 22.25ZM9 2.25C6.65972 2.25 4.92432 2.66107 3.7927 3.7927C2.66107 4.92432 2.25 6.65972 2.25 9V15C2.25 17.3403 2.66107 19.0757 3.7927 20.2073C4.92432 21.3389 6.65972 21.75 9 21.75H15C17.3403 21.75 19.0757 21.3389 20.2073 20.2073C21.3389 19.0757 21.75 17.3403 21.75 15V9C21.75 6.65972 21.3389 4.92432 20.2073 3.7927C19.0757 2.66107 17.3403 2.25 15 2.25H9Z",
    fill: "#6C727F",
    stroke: "#6C727F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/Advertising.3496366029432a7aec4d490e0c50642f.svg";
export { ForwardRef as ReactComponent };